export default function () {

    window.addEventListener('resize', function(event){
        offsetModule();
    })

    window.addEventListener('load', function(event){
        offsetModule(true);
    })

    function offsetModule(load = false){

        var width = document.body.clientWidth;

        // Offset Header - Add padding to top of module to offset header - Add '.offset-header' to module
        const offsetheader = document.querySelectorAll('.offset-header');
        offsetheader.forEach( function(module) {
            var merge_padding = 0,
                offset_header = getAbsoluteHeight(document.querySelector('.main-header')),
                module_current = module.currentStyle || window.getComputedStyle(module),
                current_padding_top = 0

            if( load ) {
                current_padding_top = parseInt(module_current.paddingTop)
            } else {
                current_padding_top = (parseInt(module_current.paddingTop) < offset_header) ? parseInt(module_current.paddingTop) - offset_header : 0
                current_padding_top = (current_padding_top < 0) ? 0 : current_padding_top 
            }
            merge_padding = current_padding_top + offset_header
            module.style.removeProperty('padding-top')
            module.style.setProperty('padding-top', merge_padding + 'px', 'important')           
        });
    }

    function getAbsoluteHeight(el) {
        el = (typeof el === 'string') ? document.querySelector(el) : el; 
        var styles = window.getComputedStyle(el);
        var margin = parseFloat(styles['marginTop']) +
                     parseFloat(styles['marginBottom']);
        return el.offsetHeight + margin;
    }
}